import { Link, useParams } from "react-router-dom";
import "./historique.css";
import { useEffect, useState } from "react";
import { CommandeCommercial } from "../../../Modeles/Commande";
import AfficheCommandeCommercial from "../../../Services/Admin/AfficheCommandeCommercial";
import { NewSidebareCommercial } from "../../NewSideBareCommercial";
import axios from "axios";
import { formatCodeCommande } from "../../../Services/CodeTrackingHelper";

export interface commandeType {
  product: CommandeCommercial[];
  messageErros: string;
}

export default function HistoriqueCommandeCommercial() {
  const { id } = useParams<{ id: string }>();
  const commercialId = id || localStorage.getItem("CommercialId") || "";

  const [state, setState] = useState<commandeType>({
    product: [] as CommandeCommercial[],
    messageErros: "Aucune commande",
  });

  const itemsPerPage = 10;
  const [loading, setLoading] = useState<boolean>(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  // Annulation state
  const [annulConfirm, setAnnulConfirm] = useState<{ id: number | null; open: boolean }>({
    id: null,
    open: false,
  });
  const [annulLoading, setAnnulLoading] = useState(false);
  const [annulMsg, setAnnulMsg] = useState<{ text: string; type: 'success' | 'error' } | null>(null);
  const commercialName = localStorage.getItem('CommercialName') || `Commercial #${commercialId}`;

  const handleAnnuler = async (idCommande: number) => {
    setAnnulLoading(true);
    try {
      await axios.post(
        `${process.env.REACT_APP_PHP_APP_URL}/commercial/${commercialId}/commande/${idCommande}/annuler`,
        { commercialName }
      );
      // Update local state
      setState(prev => ({
        ...prev,
        product: prev.product.map(p =>
          p.id === idCommande ? { ...p, Statut: 'annulé' } : p
        ),
      }));
      setAnnulMsg({ text: `Commande #${idCommande} annulée avec succès.`, type: 'success' });
    } catch {
      setAnnulMsg({ text: 'Erreur lors de l\'annulation. Veuillez réessayer.', type: 'error' });
    } finally {
      setAnnulLoading(false);
      setAnnulConfirm({ id: null, open: false });
      setTimeout(() => setAnnulMsg(null), 4000);
    }
  };

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    setLoading(true);
    AfficheCommandeCommercial()
      .GetCommandeCommercial(commercialId)
      .then((res) => {
        const allProducts = Array.isArray(res.data) ? res.data : [];
        setState({ ...state, product: allProducts });
      })
      .catch((err) => {
        setState({ ...state, product: [] });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [commercialId]);

  const [filterType, setFilterType] = useState<'week' | 'month' | 'all'>('all');

  const handleChangePage = (pageNumber: number) => {
    setCurrentPage(pageNumber);
  };

  const { product, messageErros } = state;

  const filteredProducts = Array.isArray(product) ? product.filter(p => {
    if (filterType === 'all') return true;
    if (!p.Date) return false;
    const orderDate = new Date(p.Date);
    const now = new Date();
    const diffTime = Math.abs(now.getTime() - orderDate.getTime());
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (filterType === 'week') {
      return diffDays <= 7;
    }
    if (filterType === 'month') {
      return diffDays <= 30;
    }
    return true;
  }) : [];

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);

  const pageNumbers: number[] = [];
  for (let i = 1; i <= Math.ceil(filteredProducts.length / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  const getStatusClass = (statut: string) => {
    if (statut === "confirmé" || statut === "confirme") return "hist-status--confirmed";
    if (statut === "annulé" || statut === "annuler") return "hist-status--cancelled";
    return "hist-status--pending";
  };

  /* ========== MOBILE ========== */
  if (screenWidth <= 768) {
    return (
      <>
        <NewSidebareCommercial />

        {/* Confirmation Modal */}
        {annulConfirm.open && (
          <div style={{
            position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
          }}>
            <div style={{
              background: '#fff', borderRadius: '12px', padding: '32px 28px',
              maxWidth: '380px', width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
              textAlign: 'center'
            }}>
              <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>⚠️</div>
              <h3 style={{ margin: '0 0 8px', color: '#1e293b', fontWeight: 700 }}>Confirmer l'annulation</h3>
              <p style={{ color: '#64748b', marginBottom: '24px', fontSize: '0.95rem' }}>
                Êtes-vous sûr de vouloir annuler la commande <strong>#{annulConfirm.id}</strong> ?
                Un email sera envoyé au magasin.
              </p>
              <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
                <button
                  onClick={() => setAnnulConfirm({ id: null, open: false })}
                  disabled={annulLoading}
                  style={{
                    padding: '10px 24px', borderRadius: '8px', border: '1px solid #e2e8f0',
                    background: '#f8fafc', color: '#475569', fontWeight: 600, cursor: 'pointer'
                  }}
                >
                  Annuler
                </button>
                <button
                  onClick={() => annulConfirm.id && handleAnnuler(annulConfirm.id)}
                  disabled={annulLoading}
                  style={{
                    padding: '10px 24px', borderRadius: '8px', border: 'none',
                    background: annulLoading ? '#94a3b8' : '#ef4444', color: '#fff',
                    fontWeight: 700, cursor: annulLoading ? 'not-allowed' : 'pointer',
                    display: 'flex', alignItems: 'center', gap: '8px'
                  }}
                >
                  {annulLoading ? '...' : '✓ Confirmer'}
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Toast notification */}
        {annulMsg && (
          <div style={{
            position: 'fixed', bottom: '24px', left: '50%', transform: 'translateX(-50%)',
            background: annulMsg.type === 'success' ? '#22c55e' : '#ef4444',
            color: '#fff', padding: '12px 24px', borderRadius: '8px',
            fontWeight: 600, zIndex: 9998, boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
          }}>
            {annulMsg.text}
          </div>
        )}

        <div className="hist-mobile-wrapper">
          <div className="hist-mobile-header">
            <h2 className="hist-mobile-title">Historique</h2>
            <span className="hist-badge">
              {filteredProducts.length} commande{filteredProducts.length !== 1 ? "s" : ""}
            </span>
          </div>

          {loading ? (
            <div className="hist-loading">
              <div className="hist-spinner"></div>
              <span className="hist-loading-text">Chargement...</span>
            </div>
          ) : currentItems.length > 0 ? (
            currentItems.map((item, index) => (
              <div key={index} className="hist-mobile-card">
                <div className="hist-mobile-card-header">
                  <span className="hist-mobile-card-id" style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
                    {formatCodeCommande((item as any).RefCommande, item.id, item.Date)}
                  </span>
                  <span className={`hist-status ${getStatusClass(item.Statut)}`}>
                    <span className="hist-status-dot"></span>
                    {item.Statut}
                  </span>
                </div>
                <div>
                  <div className="hist-mobile-row">
                    <span className="hist-mobile-label">Commercial</span>
                    <span className="hist-mobile-value">{item.NomCommercial}</span>
                  </div>
                  <div className="hist-mobile-row">
                    <span className="hist-mobile-label">Total</span>
                    <span className="hist-mobile-value">
                      {item.Total ?? (item as any).TotalCommandeTTC ?? (item as any).TotalCommandeHT ?? '0.00'} MAD
                    </span>
                  </div>
                  <div className="hist-mobile-row">
                    <span className="hist-mobile-label">Magasin Retrait</span>
                    <span className="hist-mobile-value" style={{ fontWeight: 600, color: '#2563EB' }}>
                      {(item as any).MagasinRetrait || (item as any).SocieteLivraison || '—'}
                    </span>
                  </div>
                  <div className="hist-mobile-row">
                    <span className="hist-mobile-label">Date</span>
                    <span className="hist-mobile-value">{item.Date}</span>
                  </div>
                </div>
                <div className="hist-mobile-actions" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginTop: '12px' }}>
                  <Link className="hist-mobile-detail-btn" to={`/commercials/${commercialId}/historiques/${item.id}`}>
                    Détail <i className="bi bi-eye-fill"></i>
                  </Link>
                  <Link 
                    to={`/commercials/${commercialId}/historiques/${item.id}/rembourser`}
                    className="hist-action-btn hist-btn-refund"
                    style={{
                      padding: '6px 12px', fontSize: '12px', backgroundColor: '#F59E0B',
                      color: 'white', textDecoration: 'none', borderRadius: '4px',
                      cursor: 'pointer', display: 'inline-block'
                    }}
                  >
                    Remboursement
                  </Link>
                  <button
                    disabled={item.Statut === 'annulé' || item.Statut === 'annuler'}
                    onClick={() => setAnnulConfirm({ id: item.id ?? null, open: true })}
                    style={{
                      padding: '6px 12px', fontSize: '12px',
                      backgroundColor: (item.Statut === 'annulé' || item.Statut === 'annuler') ? '#94a3b8' : '#ef4444',
                      color: 'white', border: 'none', borderRadius: '4px',
                      cursor: (item.Statut === 'annulé' || item.Statut === 'annuler') ? 'not-allowed' : 'pointer'
                    }}
                  >
                    {(item.Statut === 'annulé' || item.Statut === 'annuler') ? 'Annulée' : '✕ Annuler'}
                  </button>
                </div>
              </div>
            ))
          ) : (
            <div className="hist-empty">
              <div className="hist-empty-icon">
                <i className="bi bi-inbox"></i>
              </div>
              <h5>{messageErros}</h5>
              <p>Aucune commande n'a été trouvée.</p>
            </div>
          )}

          {pageNumbers.length > 1 && (
            <div className="hist-pagination">
              <button
                className={`hist-page-btn hist-page-nav ${currentPage === 1 ? "disabled" : ""}`}
                onClick={() => handleChangePage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ← Préc.
              </button>
              {pageNumbers.map((number) => (
                <button
                  key={number}
                  className={`hist-page-btn ${currentPage === number ? "active" : ""}`}
                  onClick={() => handleChangePage(number)}
                >
                  {number}
                </button>
              ))}
              <button
                className={`hist-page-btn hist-page-nav ${currentPage === pageNumbers.length ? "disabled" : ""}`}
                onClick={() => handleChangePage(currentPage + 1)}
                disabled={currentPage === pageNumbers.length}
              >
                Suiv. →
              </button>
            </div>
          )}
        </div>
      </>
    );
  }

  /* ========== DESKTOP ========== */
  return (
    <div className="hist-page-wrapper">
      <NewSidebareCommercial />

      {/* Confirmation Modal */}
      {annulConfirm.open && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.55)',
          display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 9999
        }}>
          <div style={{
            background: '#fff', borderRadius: '12px', padding: '32px 28px',
            maxWidth: '400px', width: '90%', boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
            textAlign: 'center'
          }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '12px' }}>⚠️</div>
            <h3 style={{ margin: '0 0 8px', color: '#1e293b', fontWeight: 700 }}>Confirmer l'annulation</h3>
            <p style={{ color: '#64748b', marginBottom: '24px', fontSize: '0.95rem' }}>
              Êtes-vous sûr de vouloir annuler la commande <strong>#{annulConfirm.id}</strong> ?
              Un email sera envoyé au magasin.
            </p>
            <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
              <button
                onClick={() => setAnnulConfirm({ id: null, open: false })}
                disabled={annulLoading}
                style={{
                  padding: '10px 24px', borderRadius: '8px', border: '1px solid #e2e8f0',
                  background: '#f8fafc', color: '#475569', fontWeight: 600, cursor: 'pointer'
                }}
              >
                Fermer
              </button>
              <button
                onClick={() => annulConfirm.id && handleAnnuler(annulConfirm.id)}
                disabled={annulLoading}
                style={{
                  padding: '10px 24px', borderRadius: '8px', border: 'none',
                  background: annulLoading ? '#94a3b8' : '#ef4444', color: '#fff',
                  fontWeight: 700, cursor: annulLoading ? 'not-allowed' : 'pointer'
                }}
              >
                {annulLoading ? 'Annulation...' : '✓ Confirmer'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {annulMsg && (
        <div style={{
          position: 'fixed', bottom: '32px', right: '32px',
          background: annulMsg.type === 'success' ? '#22c55e' : '#ef4444',
          color: '#fff', padding: '14px 28px', borderRadius: '10px',
          fontWeight: 600, zIndex: 9998, boxShadow: '0 4px 24px rgba(0,0,0,0.18)'
        }}>
          {annulMsg.text}
        </div>
      )}

      <div className="hist-page-inner">
        <div className="hist-header">
          <h1 className="hist-title">Historique des commandes</h1>
          {!loading && (
            <span className="hist-badge">
              {filteredProducts.length} commande{filteredProducts.length !== 1 ? "s" : ""}
            </span>
          )}
        </div>

        {/* Filter Bar */}
        <div className="hist-filter-bar">
          <button 
            className={`hist-filter-btn ${filterType === 'week' ? 'active' : ''}`}
            onClick={() => { setFilterType('week'); setCurrentPage(1); }}
          >
            <i className="bi bi-calendar-week"></i> Cette semaine
          </button>
          <button 
            className={`hist-filter-btn ${filterType === 'month' ? 'active' : ''}`}
            onClick={() => { setFilterType('month'); setCurrentPage(1); }}
          >
            <i className="bi bi-calendar-month"></i> Ce mois
          </button>
          <button 
            className={`hist-filter-btn ${filterType === 'all' ? 'active' : ''}`}
            onClick={() => { setFilterType('all'); setCurrentPage(1); }}
          >
            <i className="bi bi-calendar3"></i> Tout
          </button>
        </div>

        {/* Content */}
        {loading ? (
          <div className="hist-loading">
            <div className="hist-spinner"></div>
            <span className="hist-loading-text">Chargement...</span>
          </div>
        ) : currentItems.length > 0 ? (
          <>
            <div className="hist-table-container">
              <table className="hist-table">
                <thead>
                  <tr>
                    <th>N° Commande</th>
                    <th>Magasin Retrait</th>
                    <th>Montant</th>
                    <th>Statut</th>
                    <th>Détails</th>
                    <th>Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((pro, index) => (
                    <tr key={index}>
                      <td>
                        <span className="hist-order-id" style={{ fontFamily: 'monospace', fontSize: '0.8rem' }}>
                          {formatCodeCommande((pro as any).RefCommande, pro.id, pro.Date)}
                        </span>
                      </td>
                      <td>
                        <span style={{ fontWeight: 600, color: '#2563EB', fontSize: '0.85rem' }}>
                          {(pro as any).MagasinRetrait || (pro as any).SocieteLivraison || '—'}
                        </span>
                      </td>
                      <td>
                        <span className="hist-amount">
                          {pro.Total ?? (pro as any).TotalCommandeTTC ?? (pro as any).TotalCommandeHT ?? '0.00'} MAD
                        </span>
                      </td>
                      <td>
                        <span className={`hist-status ${getStatusClass(pro.Statut)}`}>
                          <span className="hist-status-dot"></span>
                          {pro.Statut}
                        </span>
                      </td>
                      <td>
                        <Link className="hist-detail-link" to={`/commercials/${commercialId}/historiques/${pro.id}`}>
                          Voir détail <i className="bi bi-eye-fill"></i>
                        </Link>
                      </td>
                      <td>
                        <span className="hist-date">{pro.Date}</span>
                      </td>
                      <td>
                        <div className="hist-actions-cell" style={{ display: 'flex', gap: '8px' }}>
                          <Link 
                            to={`/commercials/${commercialId}/historiques/${pro.id}/rembourser`}
                            className="hist-action-btn hist-btn-refund"
                            style={{
                              padding: '4px 8px', fontSize: '12px', backgroundColor: '#F59E0B',
                              color: 'white', textDecoration: 'none', borderRadius: '4px',
                              cursor: 'pointer', display: 'inline-block'
                            }}
                          >
                            Remboursement
                          </Link>
                          <button
                            disabled={pro.Statut === 'annulé' || pro.Statut === 'annuler'}
                            onClick={() => setAnnulConfirm({ id: pro.id ?? null, open: true })}
                            style={{
                              padding: '4px 10px', fontSize: '12px', border: 'none',
                              backgroundColor: (pro.Statut === 'annulé' || pro.Statut === 'annuler') ? '#94a3b8' : '#ef4444',
                              color: 'white', borderRadius: '4px',
                              cursor: (pro.Statut === 'annulé' || pro.Statut === 'annuler') ? 'not-allowed' : 'pointer',
                              fontWeight: 600
                            }}
                          >
                            {(pro.Statut === 'annulé' || pro.Statut === 'annuler') ? 'Annulée' : '✕ Annuler'}
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {pageNumbers.length > 1 && (
              <div className="hist-pagination">
                <button
                  className={`hist-page-btn hist-page-nav ${currentPage === 1 ? "disabled" : ""}`}
                  onClick={() => handleChangePage(currentPage - 1)}
                  disabled={currentPage === 1}
                >
                  ← Précédent
                </button>
                {pageNumbers.map((number) => (
                  <button
                    key={number}
                    className={`hist-page-btn ${currentPage === number ? "active" : ""}`}
                    onClick={() => handleChangePage(number)}
                  >
                    {number}
                  </button>
                ))}
                <button
                  className={`hist-page-btn hist-page-nav ${currentPage === pageNumbers.length ? "disabled" : ""}`}
                  onClick={() => handleChangePage(currentPage + 1)}
                  disabled={currentPage === pageNumbers.length}
                >
                  Suivant →
                </button>
              </div>
            )}
          </>
        ) : (
          <div className="hist-empty">
            <div className="hist-empty-icon">
              <i className="bi bi-inbox"></i>
            </div>
            <h5>Aucune commande</h5>
            <p>Vos commandes apparaîtront ici une fois passées.</p>
          </div>
        )}
      </div>
    </div>
  );
}